import { IdentityDocumentTypeEnum } from '../../../enums/identity-document-type.enum';

/**
 * Applies create-path defaults for driver-owned entities.
 * An omitted document type becomes an ID card. An explicit null stays empty.
 */
export function applyDriverCreateDefaults<
  T extends {
    identityDocumentType?: IdentityDocumentTypeEnum | null;
  },
>(driver: T): T {
  if (driver.identityDocumentType === undefined) {
    driver.identityDocumentType = IdentityDocumentTypeEnum.ID_CARD;
  }

  return driver;
}
